import { createFileRoute } from "@tanstack/react-router"
import DesignSystemBadges from "~/pages/design-system/components/Badges"

export const Route = createFileRoute("/_auth/internal/design-system/components/badges")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemBadges />
}
